import { Link } from "react-router-dom";
import { Section, Eyebrow } from "@/components/Primitives";

export default function Disclaimer() {
  return (
    <div className="pb-8">
      <Section className="pt-14 sm:pt-20 max-w-3xl">
        <Eyebrow>Please read with care</Eyebrow>
        <h1 className="font-serif-display text-4xl sm:text-5xl text-stone-900 mt-4">Care Disclaimer</h1>

        <div className="mt-8 bg-white rounded-2xl border border-stone-200 p-7 space-y-5 text-stone-700 leading-relaxed">
          <p>
            <strong>A supportive tool, not treatment.</strong> The assessments, content, book,
            sessions, and hypnotherapy described on this site are offered as supportive,
            science-informed and faith-informed tools that <em>may</em> help. They are not medical
            care, mental-health treatment, diagnosis, or a cure, and they do not replace the advice
            of qualified professionals.
          </p>
          <p>
            <strong>No promised outcomes.</strong> Everyone is different. We describe the quality of
            our process, not guaranteed results. Nothing here should be read as a promise that a
            particular outcome will occur.
          </p>
          <p>
            <strong>Complement appropriate care.</strong> If you are working with a doctor,
            therapist, counselor, or recovery program, this work is meant to complement that care —
            please continue it and consult your providers before making changes.
          </p>
          <p>
            <strong>Assessments are for reflection.</strong> Our self-assessments are educational
            reflections, not clinical instruments or diagnoses. Their summaries are meant to help you
            notice patterns and consider next steps.
          </p>
          <p>
            <strong>Not HIPAA-compliant.</strong> We are not presenting this site as HIPAA-compliant.
            Please avoid sharing detailed clinical or sensitive health information through our forms.
          </p>
          <p className="bg-[#F5F2EA] rounded-xl p-4">
            <strong>In an emergency.</strong> If you or someone else is in danger or crisis, do not
            use this site — contact your local emergency number or a crisis line immediately.
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-4">
          <Link to="/consultation" data-testid="disclaimer-consultation-cta" className="btn-terracotta rounded-full px-6 py-3.5 text-sm font-semibold">
            Request a free consultation
          </Link>
          <Link to="/privacy" data-testid="disclaimer-privacy-link" className="rounded-full px-6 py-3.5 text-sm font-semibold border border-stone-300 text-stone-700 hover:bg-white">
            Read our privacy policy
          </Link>
        </div>
      </Section>
    </div>
  );
}
